<template lang="pug">
  div(v-if="opened")
    transition
      .modal
        div.modal__container
          div.modal__body
            e-form(:formValidator="formValidator")
              div.body
                div.col
                  e-form-group(
                    name="startAddress"
                    inputType="address"
                    label="Начальная точка"
                    :model="fields"
                    tabView="tab1"
                    :required="true"
                    :addressData="addressData"
                    @selectItem="onSelectAddress"
                  )

                  e-form-group(
                    name="tkoObjectId"
                    inputType="select"
                    label="Место размещения отхода"
                    :model="fields"
                    tabView="tab1"
                    :required="true"
                    :options="tkoObjects"
                    @change="onChangeAddressTkoObject"
                  )

                  e-form-group(
                    name="routeVolume"
                    inputType="input"
                    label="Максимальный объем рейса"
                    :model="fields"
                    tabView="tab1"
                    :required="true"
                    validationRule="double"
                  )

                  e-form-group(
                    name="includeAdditionalPoints"
                    :model="fields"
                    tabView="tab1"
                    caption="Дополнительные точки"
                    inputType="checkbox"
                  )

          div.modal__footer
            div.actions-filter-panel.actions-filter-panel--right
              div
                button(type="button" @click="close()").reset-btn.button.button_no-border.button_color.modal__button Отмена
                template(v-if="freezed")
                  button(v-if="userCanCreate" type="button" @click="").button.reset-btn.button_usual.modal__button Формирование...
                template(v-else)
                  button(v-if="userCanCreate" type="button" @click="sendForm()").button.reset-btn.button_usual.modal__button Сформировать
</template>

<script>
import { atu } from '@/api/api-endpoints'
import formBaseMixin from '@/components/form/form-base-mixin'
import Route from '../models/Route'
import { prepareObjectModel } from '../utils/transformers'

export default {
  name: 'auto-route',
  mixins: [formBaseMixin],
  title: false,
  props: {
    tkoObjects: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      opened: false,
      freezed: true,
      locationItems: [],
      addressData: {},
      fields: {
        location: '',
        count: '',
        routeVolume: '',
        startAddress: '',
        startPoint: {
          coords: [],
          address: '',
          data: null,
        },
        tkoObjectId: '',
        includeAdditionalPoints: false,
        endAddress: '',
        endPoint: {},
      },
      objectsByLocations: [],
    }
  },
  methods: {
    async getObjectsByLocations() {
      this.objectsByLocations = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: atu.atuObjects({ query: { 'per-page': -1 } }),
          fromCache: false,
        })
      ).data.data
    },
    onChangeAddressTkoObject() {
      this.tkoObjects.forEach((item) => {
        if (item.id === this.fields.tkoObjectId) {
          this.fields.endPoint = {
            object_id: item.id,
            object_type: 'tko_object',
            coords: [item.latitude, item.longitude],
          }
          this.fields.endAddress = `${item.name}, ${item.address}`
        }
      })
    },
    onSelectAddress({ data, value }) {
      this.fields.startAddress = value
      this.fields.startPoint = {}
      this.fields.startPoint.coords = [+data.geo_lat, +data.geo_lon]
      this.fields.startPoint.address = value
      this.fields.startPoint.data = data
    },
    getObjectOfSelectedLocation() {
      // get route count
      let locationItems = this.objectsByLocations
        .filter((v) => v.name === this.fields.location)
        .map(prepareObjectModel)
      let filteredItems = []
      // если галка доп - добавляем все дополнительные точки
      if (this.fields.includeAdditionalPoints) {
        //TODO проверить как только эти точки появятся в БД
        locationItems.forEach((msn) => {
          if (+msn.msn_type_id === 2) {
            filteredItems.push(msn)
          }
        })
      }
      if (filteredItems.length > 0) {
        locationItems = { locationItems, ...filteredItems }
      }
      return [...new Set(locationItems)]
    },
    saveForm() {
      if (this.freezed) {
        return
      }
      const items = this.getObjectOfSelectedLocation()
      let chunkSize = 20
      let parts = []
      for (let i = 0, c = items.length; i <= c; i += chunkSize) {
        let chunk = items.slice(i, i + chunkSize)
        if (chunk) {
          parts.push(chunk)
        }
      }
      const routes = []
      let route = new Route(this.fields.startPoint)
      route.endPoint = this.fields.endPoint
      route.mass = this.fields.routeVolume
      route.points = []
      route.points.push(this.fields.endPoint)
      routes.push(route)

      if (routes.length === 0) {
        throw new Error('Нет контейнеров подходящих под условия')
      }
      this.$emit('routesGenerated', routes)
    },
    freeze() {
      this.freezed = true
    },
    open() {
      this.opened = true
      this.freezed = false
    },
    close() {
      this.opened = false
      this.freezed = true
      this.fields = Object.assign(
        {},
        {
          location: '',
          count: '',
        }
      )
    },
  },
  created() {
    this.getObjectsByLocations()
  },
}
</script>
